/*
 * File: components/TitleCard.tsx
 * Author: Hannah Murphy
 * Date: 2024
 * Description: A title card component.
 *
 * Copyright (c) 2024 WESMO. All rights reserved.
 * This code is part of the  WESMO Data Acquisition and Visualisation Project.
 */

import React from "react";
import "./TitleCard.css";

const TitleCard = ({ title }) => {
  return <div className="title-card">{title}</div>;
};

export default TitleCard;
